import api from '../api';

const noticeService = {
    /**
     * Get all notices for a team with pagination
     */
    getNotices: async (teamId, page = 1, perPage = 15) => {
        return await api.get(`/v1/teams/${teamId}/notices`, {
            params: { page, perPage },
        });
    },

    /**
     * Create a new notice
     */
    createNotice: async (data) => {
        return await api.post('/v1/notices', data);
    },

    /**
     * Update a notice
     */
    updateNotice: async (id, data) => {
        return await api.put(`/v1/notices/${id}`, data);
    },

    /**
     * Delete a notice
     */
    deleteNotice: async (id) => {
        return await api.delete(`/v1/notices/${id}`);
    },
};

export default noticeService;
